module.exports = __webpack_public_path__ + "assets/img/6.6e383431.png";